<template>
    <div id="MostrarEnvioMensaje">
        <h2>Nuevo mensaje <a v-show="mensaje_titulo!=''">de</a> {{mensaje_titulo}}</h2>     
        <hr  id="Linea">
        <h3>Tipo de mensaje</h3>
        <!-- lista para seleccionar el tipo de mensaje -->
        <div id="TipoMensaje" >
            <h4 v-bind:style= "[mensaje_barra=='Selecciona el tipo de mensaje'? { color:'#ccc', fontStyle: 'oblique'} : {color:'#999', fontWeight: 600 }]">{{mensaje_barra}}</h4>
            <button id="BotonesBarra" v-on:click="bandera_tipo_mensaje=!bandera_tipo_mensaje" >
                <img src="../assets/Flecha_select.png" style="width:50%">
            </button>
        </div>
        <div v-if="bandera_tipo_mensaje" id="ListaTipoMensaje" class="transition">
            <button v-on:click="valorTipoMensaje(opcion)" v-for="opcion in opciones_mensaje" :key="opcion" id="OpcionesMensaje"> {{opcion}}</button>
        </div>
        <hr id="Espacio">
        <!-- lista para seleccionar el asunto del mensaje -->
        <div v-show="estados==1 ||estados==2 || estados==3 || mensaje_barra!='Selecciona el tipo de mensaje'">
            <h3>Asunto de mensaje</h3>
            <div id="TipoMensaje">
                <h4 v-bind:style= "[mensaje_barra2=='Selecciona el asunto del mensaje'? { color:'#ccc', fontStyle: 'oblique'} : {color:'#999', fontWeight: 600 }]">{{mensaje_barra2}}</h4>
                <button id="BotonesBarra" v-on:click="bandera_asunto_mensaje=!bandera_asunto_mensaje" >
                    <img src="../assets/Flecha_select.png" style="width:50%">
                </button>
            </div>
            <div v-if="bandera_asunto_mensaje" id="ListaTipoMensaje" class="transition">
                <button v-on:click="valorTipoMensaje(opcion)" v-for="opcion in opciones_asunto" :key="opcion" id="OpcionesMensaje"> {{opcion}}</button>
            </div>
            <hr id="Espacio">
        </div>
        <!-- Dependiendo del formato de mensaje seleccionado se cargan en esta sección los botones de seleccion del mensaje de multiedia, el audio grabado del mensaje de audio o el imput para el ingreso del mensaje de texto -->
        <div v-show="estados==3 || estados==4">
            <h3>{{mensaje_titulo}}</h3>
            <button  v-on:click="valorTipoMensaje(tipo)" v-show="mensaje_titulo=='multimedia'" id="BotonesTipoArchivo" v-for="tipo in tipos_archivo" :key="tipo">{{tipo}}</button>
            <div id="InfoAudio">
                <ul id="audio"></ul>
                <!--<button v-if="audio_ok==true" class="upload" id="upload" @click="uploadAudio()"><img src="../assets/Repetir.png" width="20px" height="20px" alt=""></button> -->
            </div>
            <input v-on:keyup.enter="EnvioMensajeChat()" id="inputMensajeTextoPanel" v-model="mensaje_enviar" v-show="mensaje_titulo=='texto'" type="text" placeholder="Ingresa tu mensaje...">
        </div>
        <!-- Cuando se selecciona el video a enviar se carga en esta sección la sinopsis del video y se habilita el ingreso del mensaje complementario -->
        <div v-show="estados==4">
            <div id="SinopsisVideo">
                <img id="ImgVideo" :src="imagenVideo" style="width:50%; height:50%">
                <h6>{{nombreVideo}}</h6>
                <button id="BotonEliminarPacientes" @click="eliminarVideoPanel()"><img src="../assets/delete.png" style="width:50%"></button>
            </div>
            <h3>Mensaje complementario</h3>
            <input v-on:keyup.enter="EnvioMensajeChat()" id="inputMensajeComplementarioPanel" v-model="mensaje_enviar" type="text" placeholder="Escriba aqui su mensaje...">
        </div>
        <!-- el boton de enviar se muestra cuando se diligencian todos los campos obligatorios relacionados con el formato de mensaje a enviar -->
        <div id="BotonesEnvioMensaje">
            <button v-show="activaEnvioDatos" id="enviar_mensaje" v-on:click="enviarMensajePanel()">Enviar</button>
            <button v-show="activaEnvioDatos" id="enviar_mensaje" v-on:click="editarMensajePanel()">Editar</button>
        </div>
    </div>
</template>
<script>
import { serverBus } from '../main'

export default {
    data(){
        return{
            bandera_tipo_mensaje:false,
            bandera_asunto_mensaje:false,
            mensaje_barra:'Selecciona el tipo de mensaje',
            mensaje_barra2:'Selecciona el asunto del mensaje',
            // esta variable cambia cuando el usuario selecciono el tipo de mensaje(formato)
            mensaje_titulo:'', 
            opciones_mensaje:["Médico", "Rehabilitación", "Tabaquismo", "Especial", "Automático"],
            tipos_archivo:["Video", "URL", "Imagen","GIF"],
            opciones_asunto:["Bienvenida","Recordatorio de ejercicios", "Felicitaciones"],
            videos:[{
                //nombre:'Fortalecimiento de abductores',
                //imagen:'../assets/DemoVideo.png'
            }],
            mensaje_complementario:'Aún no se ha escrito mensaje complementario',
            videoSeleccionado:false,
            mensaje_enviar:'',
            valor_boton_multimedia:'',
            nombreVideo:'',
            imagenVideo:'',
            estados:0,
            audio_ok:false,
            activaEnvioDatos:false
        }
    },
    created(){
        serverBus.$on('actualizarEstados', (estado) =>{
            this.estados = estado[0]
            try {
                switch (this.estados){
                    case 1:
                        this.mensaje_barra = estado[1]
                        break
                    case 2:
                        this.mensaje_barra2 = estado[1]
                        break
                    case 3:
                        this.mensaje_titulo = estado[1]
                        break
                    case 4://video cargado
                        this.videoSeleccionado = true
                        let video = estado[1]
                        this.nombreVideo = video.nombre
                        this.imagenVideo = video.imagen
                        this.mensaje_enviar=''
                        document.getElementById("inputMensajeComplementarioPanel").disabled = false;
                        break
                }
            }
                catch(err) {
            }
            //console.log("estados desde mensajes",estado, this.nombreVideo,this.imagenVideo, this.estados)
        }),
        // Recepción del audio grabado desde el chatbox para ser visualizado en el panel de mensaje
        serverBus.$on('archivosAdjuntos', (archivo) =>{
            document.getElementById("audio").appendChild(archivo)
            this.audio_ok=true
        }),
        //Recibe la confirmación para activar el boton de enviar mensaje desde el panel de mensaje
        serverBus.$on('visualizarBotonEnvioDatos', (banderaEnvioDatos) =>{
            this.activaEnvioDatos = banderaEnvioDatos
            
        }),
        /**Cuando desde el chatbox se escribe la selección del tipo de mensaje multimedia a enviar (video, url, imagen,etc),
         * se recibe dicha opción en el panel de mensaje y se selecciona el boton con el valor correspondiente a la selleción 
         * hecha desde el chatbox*/
        serverBus.$on('activarBotonMultimedia', (boton) =>{
            this.valor_boton_multimedia=boton
            console.log('valor_boton_multimedia',  this.valor_boton_multimedia)
            document.getElementById("BotonesTipoArchivo").style.background= '#33ccff'
            document.getElementById("BotonesTipoArchivo").style.color='white'
        }),
        /**Se recibe la bandera de mensaje enviado cuando desde el chatbox se confirmó el envio del mensaje, en ese momento se 
         * llama la función resetear para regresar a las variables a su valor inicial y permitirle al usuario hacer una nueva selección  */
        serverBus.$on('MensajeEnviado', (bandera_mensaje_enviado) =>{
            this.resetear()
            
        }),
        /**
         * 
         */
        serverBus.$on('MensajeEnviado_desde_chat', (mensaje_chat) =>{
            this.mensaje_enviar=mensaje_chat
            document.getElementById("inputMensajeTextoPanel").disabled = true;
            document.getElementById("inputMensajeComplementarioPanel").disabled = true;
        }),
        /**
         * Funcion para limpiar el mensaje cuando se selecciona editar desde chat
         */
        serverBus.$on('editar_mensaje_desde_chat', (mensaje_chat) =>{
            document.getElementById("inputMensajeTextoPanel").disabled = false;
            document.getElementById("inputMensajeComplementarioPanel").disabled = false;
            document.getElementById("BotonesTipoArchivo").style.background= 'white'
            document.getElementById("BotonesTipoArchivo").style.color='#999999'
            this.mensaje_enviar = ""
            this.estados=2
            this.activaEnvioDatos=false
            this.eliminarMensajesAudio()
        })
        
    },
    props: {
       tipo_mensaje: Boolean,
    },
    methods:{
        /**Esta funcion permite que la barra de selección se refresque 
         * con el valor seleccionado de la lista desplegable. Valida 
         * para la lista de tipo de mensaje y asunto */
        valorTipoMensaje:function(value){
            
            /**if para tipo de mensaje */
            if(this.bandera_tipo_mensaje){
                this.mensaje_barra=value
                this.bandera_tipo_mensaje=!this.bandera_tipo_mensaje
                serverBus.$emit('titulo_mensaje',this.mensaje_barra);
            }
            /**if para asunto de mensaje */
            else if(this.bandera_asunto_mensaje){
                this.mensaje_barra2=value
                this.bandera_asunto_mensaje=!this.bandera_asunto_mensaje
                serverBus.$emit('asunto_mensaje',this.mensaje_barra2);
            }
            // Selección del tipo de mensaje (video, url, GIF, etc) y envia el valor de la selección al chat
            else{
                this.valor_boton_multimedia=value
                serverBus.$emit('videoListarCategorias',this.valor_boton_multimedia);
                console.log('valor_boton_multimedia',  this.valor_boton_multimedia)
                document.getElementById("BotonesTipoArchivo").style.background= '#33ccff'
                document.getElementById("BotonesTipoArchivo").style.color='white'
                this.nombreVideo = ""
                this.imagenVideo = ""
                this.estados=3
            }
        },
        /**Funcion que permite enviar el texto ingresado en el panel 
         * de mensaje al chat. * Se activa con el evento enter */
        EnvioMensajeChat:function(){
            console.log('mensaje_enviar', this.mensaje_enviar)
            serverBus.$emit('mensaje_texto',this.mensaje_enviar);
            document.getElementById("inputMensajeTextoPanel").disabled = true;
            document.getElementById("inputMensajeComplementarioPanel").disabled = true;
        },
        /*
        uploadAudio:function(){
            var retVal = confirm("¿Confirma que desea repetir el audio?");
               if( retVal == true ){
                  var audio = document.getElementById("audio")
                  while(audio.getElementsByTagName("li").length > 0) {
                    var lis = audio.getElementsByTagName("li")
                    audio.removeChild(lis[0]);
                  }
                  console.log("id_audio",audio.getElementsByTagName("li").length)
                  //audio.remove();
                  document.getElementById("upload").style.visibility="hidden"
                  //this.audio_ok=false
                  //Aqui se debe redirigir al usuario en el punto de la conversación donde se graba el audio
               }
               else{

               }
        },*/
        /**Este metodo se llama cuando se selecciona el boton de enviar desde el panel de mensaje. Envia al chat 
         * la confirmación del envio de mensaje y llama la función de resetear variables */
        enviarMensajePanel:function(){
            document.getElementById("inputMensajeTextoPanel").disabled = false;
            document.getElementById("inputMensajeComplementarioPanel").disabled = false;
            document.getElementById("BotonesTipoArchivo").style.background= 'white'
            document.getElementById("BotonesTipoArchivo").style.color='#999999'
            this.$store.dispatch('setMensajeChatBox', "Enviar")
            // serverBus.$emit('confirmacionEnvioMensaje',"Enviar");
            this.resetear()
        },
        editarMensajePanel:function(){
            document.getElementById("inputMensajeTextoPanel").disabled = false;
            document.getElementById("inputMensajeComplementarioPanel").disabled = false;
            document.getElementById("BotonesTipoArchivo").style.background= 'white'
            document.getElementById("BotonesTipoArchivo").style.color='#999999'
            // serverBus.$emit('confirmacionEnvioMensaje',"editar");
            this.$store.dispatch('setMensajeChatBox', "editar")
            this.mensaje_enviar = ""
            
            this.activaEnvioDatos=false
            this.nombreVideo = ""
            this.imagenVideo = ""
            this.eliminarMensajesAudio()       

            this.estados=2
        },
        eliminarVideoPanel:function(){
            document.getElementById("inputMensajeTextoPanel").disabled = false;
            document.getElementById("inputMensajeComplementarioPanel").disabled = false;
            serverBus.$emit('videoListarCategorias',"video");
            this.mensaje_enviar = ""
            this.estados=3
            this.activaEnvioDatos=false
            this.nombreVideo = ""
            this.imagenVideo = ""
        },
        /**Función que permite formatear el panel de mensajes cuando se envia el mensaje por medio del chat o del panel */
        resetear:function(){
            this.bandera_tipo_mensaje=false,
            this.bandera_asunto_mensaje=false,
            this.mensaje_barra='Selecciona el tipo de mensaje',
            this.mensaje_barra2='Selecciona el asunto del mensaje',
            // esta variable cambia cuando el usuario selecciono el tipo de mensaje(formato)
            this.mensaje_titulo='', 
            this.opciones_mensaje=["Médico", "Rehabilitación", "Tabaquismo", "Especial", "Automático"],
            this.tipos_archivo=["Video", "URL", "Imagen","GIF"],
            this.opciones_asunto=["Bienvenida","Recordatorio de ejercicios", "Felicitaciones"],
            this.videos=[{
                //nombre:'Fortalecimiento de abductores',
                //imagen:'../assets/DemoVideo.png'
            }],
            this.mensaje_complementario='Aún no se ha escrito mensaje complementario',
            this.videoSeleccionado=false,
            this.mensaje_enviar='',
            this.valor_boton_multimedia='',
            this.nombreVideo='',
            this.imagenVideo='',
            this.estados=0,
            this.audio_ok=false,
            this.activaEnvioDatos=false
            try{
                let audio = document.getElementById("audio")
                audio.remove();
            }catch(err){
            }

            document.getElementById("inputMensajeTextoPanel").disabled = false;
            document.getElementById("inputMensajeComplementarioPanel").disabled = false;
        },

        eliminarMensajesAudio(){
            var audio = document.getElementById("audio")
            while(audio.getElementsByTagName("li").length > 0) {
                var lis = audio.getElementsByTagName("li")
                audio.removeChild(lis[0]);
            }
            console.log("id_audio",audio,audio.getElementsByTagName("li").length)
        }
    }
    
}
</script>
<style scoped>
#BotonEliminarPacientes{
    border: none;
    background: none;
    height: 10%;
}
#BotonesEnvioMensaje{
    display: flex;
    justify-content:space-around;
    margin: 10% auto 0px auto;
}
#enviar_mensaje{
    background: white;
    border: 0.8px solid #33ccff ;
    border-radius: 35px;
    font-family: 'Nunito', sans-serif;
    font-weight: bold;
    font-size: 0.9vw;
    width: 30%;
    height: 5%;
}
#enviar_mensaje:hover {
    background-color:#33ccff;
    color:white;
}
#ImgVideo{
    border-radius: 15px;
}
#SinopsisVideo{
    margin: 2% 0% 2% 0%;
    padding: 2%;
    border: 1px solid #ccc;
    border-radius: 15px;
    display: flex;
    justify-content: space-around;
    height: 18%;

}
#BotonesTipoArchivo{
    width: 25%;
    background: white;
    border: 0.5px solid #ccc;
    height: 5%;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    font-size: 1vw;
    color: #999;
    font-weight: 600;
}
#BotonesTipoArchivo:hover{
    background-color:#33ccff;
    color:white;
}

#Espacio{
    opacity: 0;
    margin: 1%;
}
h1{
    font-family: 'Nunito', sans-serif;
    font-size: 1vw;
    color: #ccc;   
    margin: 0px;
    margin-top: 2%;
}
.transition {
  animation-name: stretch;
  animation-duration: 0.2s; 
  animation-timing-function: ease-out; 
  animation-delay: 0;
  animation-direction: alternate;
  animation-fill-mode: none;
  animation-play-state: running;
}
@keyframes stretch {
  0% {
    transform: translateY(-8%);
  }
  80% {
    transform: translateY(0%);
  }
}
#ListaTipoMensaje{
    width: 94%;
    height: 22%;
    border: 1px solid #ccc;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 15px;
    border-top: 0.2px solid #ccc;
    padding: 1% 1% 0px 1%;
    transition: margin-left .5s;
    margin-left: 3%;
    justify-content: center;
}
#OpcionesMensaje{
    display: block !important;
    background: white;
    border:none;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    font-size: 0.8vw;
    width: 80%;
    border-bottom: 0.5px solid #ccc;
    color: #999;
    height: 20%;
    font-weight: 600;
    margin: auto;
}
#OpcionesMensaje:hover{
    color: #33ccff;
}
#BotonesBarra{
    float: right;
    background: white;
    border:none;
    cursor: pointer;
    margin: auto 0px auto 0px;
    width: 8%;
    height: 80%;
    padding:0;
    display: flex;
    vertical-align: center;
    justify-content: center;
}
#upload{
    background: white;
    border:none;
    cursor: pointer;  
}
.button:active {
    background: red;
 } 
button:focus{outline:0;}
select:focus {outline:0;}
input:focus {outline:0;}
#TipoMensaje{
    width: 100%;
    border: none;
    border: 1px solid #ccc; 
    border-radius: 40px;
    height: 5%;
    display: flex;
    padding: 1%;
    padding-left: 5%;
    justify-content: space-between;
    margin-top: 2%;
    vertical-align: center;
    
}
h3{
    font-family: 'Nunito', sans-serif;
    font-weight: 650;
    font-size: 1.2vw;
    color: #666;
    margin: 15px 0px 5px 0px;
}
h6{
    font-family: 'Nunito', sans-serif;
    font-weight: 650;
    font-size: 1.1vw;
    color: #999;
    margin: 0px 2% 0px 4% ; 
}
h4{
    font-family: 'Nunito', sans-serif;
    font-size: 1vw;
    color: #666; 
    margin:auto 0% auto 0%;
}
#MostrarEnvioMensaje{
    width: 100%;
    height: 100%;
    padding: 6% 8% 6% 8%;
    overflow: auto;
    /* scroll-behavior: smooth; */
}
h2{
    font-family: 'Nunito', sans-serif;
    font-weight: bold;
    font-size: 1.7vw;
    color: #666;
    margin: 0px;
}
#Linea{
    border: 0.5px solid #ccc;
    margin: 2% 0px 2% 0px;
    width: 100%;
}
.rounded {
   -webkit-border-radius: 20px;
   -moz-border-radius: 20px;
   border-radius: 20px;
}
input[type=text]{
  width: 100%;
  height: 6%;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 0.8px solid #ccc;
  padding: 1%;
  margin-top: 2%;
  color: #999;
  font-family: 'Nunito', sans-serif;
  font-size: 1vw;
}
::placeholder{
  color: #ccc;
  font-size: 1vw;
  font-family: 'Nunito', sans-serif;
  font-style: oblique;
  
}
h3:first-letter{
    text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Mensajes.vue